import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BaseComponent } from '../core/components/base-component/base-component.component';
import { ButtonModule } from 'primeng/button';
import { MenuItemComponent } from './components/ui-components/menu-item/menu-item.component';
import { RouterModule } from '@angular/router';
import { TypographyComponent } from './components/ui-components/typography/typography.component';
import { ContainerComponent } from './components/ui-components/ui-container/container.component';
import { TitleBarComponent } from './components/ui-components/title-bar/title-bar.component';
import { WidgetBoxComponent } from './components/ui-components/widget-box/widget-box.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { WidgetContainerComponent } from './components/ui-components/widget-container/widget-container.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { UiTableComponent } from './components/ui-components/ui-table/ui-table.component';
import { UiDrawerComponent } from './components/ui-components/ui-drawer/ui-drawer.component';
import { DrawerModule } from 'primeng/drawer';
import { UiTitleContainerComponent } from './components/ui-components/ui-title-container/ui-title-container.component';
import { TagModule } from 'primeng/tag';
import { UiCardComponent } from './components/ui-components/ui-card/ui-card.component';
import { UiAvatarInfoComponent } from './components/ui-components/ui-avatar-info/ui-avatar-info.component';
import { AvatarModule } from 'primeng/avatar';
@NgModule({
  declarations: [
    BaseComponent,
    MenuItemComponent,
    TypographyComponent,
    ContainerComponent,
    TitleBarComponent,
    WidgetBoxComponent,
    WidgetContainerComponent,
    UiTableComponent,
    UiDrawerComponent,
    UiTitleContainerComponent,
    UiCardComponent,
    UiAvatarInfoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    RouterModule,
    ProgressBarModule,
    ToastModule,
    TableModule,
    InputTextModule,
    MenuModule,
    SelectModule,
    DrawerModule,
    TagModule,
    AvatarModule,
  ],
  exports: [
    MenuItemComponent,
    TypographyComponent,
    ContainerComponent,
    TitleBarComponent,
    WidgetBoxComponent,
    WidgetContainerComponent,
    UiTableComponent,
    UiDrawerComponent,
    UiTitleContainerComponent,
    UiCardComponent,
    UiAvatarInfoComponent,
  ],
})
export class SharedModule {}
